<template>
  <b-container fluid>
    <b-row>
      <b-col class="no-sided-padding">
        <b-card no-body>
          <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
            La sezione Nuova Digitalizzazione consente la digitalizzazione di nuovi regolamenti cartacei.
          </b-alert>

          <b-tabs v-model="tab" fill pills card>
            <b-tab title="Dati identificativi">
              <CustomerIdentification :nations="nations" :towns="towns"/>
            </b-tab>

            <b-tab title="Dati secondari">
              <b-row v-if="!identificationDataFilled">
                <b-col>
                  <b-alert show variant="info">
                    Inserire i dati identificativi prima di procedere con l'inserimento dei dati secondari
                  </b-alert>
                </b-col>
              </b-row>
              <CustomerSecondaryData v-show="identificationDataFilled" :nations="nations" :towns="notDismissedTowns"/>
            </b-tab>

            <b-tab title="Documento">
              <b-row v-if="!customerSecondaryDataFilled">
                <b-col>
                  <b-alert show variant="info">
                    Inserire i dati secondari prima di procedere con il caricamento del documento
                  </b-alert>
                </b-col>
              </b-row>

              <CustomerDocuments v-show="customerSecondaryDataFilled"/>
            </b-tab>

            <b-tab title="Riepilogo">
              <b-row v-if="!documentsUploaded">
                <b-col>
                  <b-alert show variant="info">
                    Inserire tutti i dati obbligatori prima di procedere con la digitalizzazione
                  </b-alert>
                </b-col>
              </b-row>

              <Summary v-show="documentsUploaded"/>
            </b-tab>
          </b-tabs>

          <template #footer>
            <div style="float: right; padding-top: 10px">
              <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></p>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import PaperAgreementsApi from '@/api/PaperAgreementsApi'
import CustomerIdentification from '@/components/new-agreement/CustomerIdentification'
import CustomerSecondaryData from '@/components/new-agreement/CustomerSecondaryData'
import CustomerDocuments from "@/components/new-agreement/CustomerDocuments.vue";
import Summary from "@/components/new-agreement/Summary";
import eventBus from '@/EventBus'
import moment from 'moment'
import TownsApi from "@/api/TownsApi";
import NationsApi from "@/api/NationsApi";

export default {
  name: 'NewAgreement',
  components: {CustomerSecondaryData, CustomerIdentification, Summary, CustomerDocuments},
  mounted() {
    eventBus.$off("digitalize")

    eventBus.$on("show-alert", () => this.showAlert = true)
    eventBus.$on("switch-tab", (tab) => this.tab = tab)
    eventBus.$on("identification-data-filled", this.fillIdentification)
    eventBus.$on("secondary-data-filled", this.fillSecondary)
    eventBus.$on("documents-data-filled", this.fillDocuments)
    eventBus.$on("digitalize", () => this.digitalize())
    eventBus.$on("reset-fields", (resetBarcode) => this.resetState(resetBarcode))
  },
  data: () => ({
    showAlert: false,
    CUSTOMER_IDENTIFICATION: 0,
    CUSTOMER_SECONDARY_DATA: 1,
    DOCUMENT: 2,
    SUMMARY: 3,
    tab: 0,
    customerSecondaryDataFilled: false,
    identificationDataFilled: false,
    documentsUploaded: false,
    digitalizing: false,
    agreement: {},
    documents: {},
    nations: [],
    towns: [],
    notDismissedTowns: []
  }),
  created() {
    TownsApi.all()
      .then(result => this.towns = result)
      .catch(err => console.error(err))

    TownsApi.nonDismissed()
      .then(result => this.notDismissedTowns = result)
      .catch(err => console.error(err))

    NationsApi.all()
      .then(result => this.nations = new Map(result.map((nation) => [nation.name.toUpperCase(), nation])))
      .catch(err => console.error(err))
  },
  methods: {
    fillDocuments(detail) {
      this.documentsUploaded = true

      this.documents = detail
    },
    fillIdentification(detail) {
      this.identificationDataFilled = true

      this.agreement.barcode = detail.barcode
      this.agreement.firstName = detail.firstName
      this.agreement.lastName = detail.lastName
      this.agreement.sex = detail.sex
      this.agreement.birthDate = detail.birthDate
      this.agreement.birthPlaceCity = detail.birthPlaceCity
      this.agreement.birthPlaceProvince = detail.birthPlaceProvince
      this.agreement.birthPlaceNation = detail.birthPlaceNation ? detail.birthPlaceNation.trim().toUpperCase() : "ITALIA";
    },
    fillSecondary(detail) {
      this.customerSecondaryDataFilled = true

      this.agreement.storeCode = detail.shopCode
      this.agreement.shopCode = detail.shopCode
      this.agreement.demandType = detail.demandType
      this.agreement.oldBarcode = detail.oldBarcode

      this.agreement.town = detail.town
      this.agreement.street = detail.street
      this.agreement.civicNumber = detail.civicNumber
      this.agreement.postalCode = detail.postalCode
      this.agreement.province = detail.province
      this.agreement.nation = detail.nation ? detail.nation.toUpperCase() : "ITALIA"

      this.agreement.email = detail.email
      this.agreement.mobilePhonePrefix = detail.mobilePhonePrefix
      this.agreement.mobilePhone = detail.mobilePhone ? `${detail.mobilePhonePrefix} ${detail.mobilePhone}` : null
      this.agreement.fiscalCode = detail.fiscalCode
      this.agreement.familyNumber = detail.familyNumber
      this.agreement.child1BirthDate = detail.child1BirthDate
      this.agreement.child2BirthDate = detail.child2BirthDate
      this.agreement.child3BirthDate = detail.child3BirthDate

      this.agreement.marketingConsensus = detail.selectedConsensuses ? detail.selectedConsensuses.includes('marketing') : false
      this.agreement.profilingConsensus = detail.selectedConsensuses ? detail.selectedConsensuses.includes('profiling') : false
      this.agreement.cooperativesConsensus = detail.selectedConsensuses ? detail.selectedConsensuses.includes('cooperatives') : false
      this.agreement.thirdPartyConsensus = detail.selectedConsensuses ? detail.selectedConsensuses.includes('third-party') : false
    },
    resetState(resetBarcode) {
      this.customerSecondaryDataFilled = false
      this.identificationDataFilled = false
      this.documentsUploaded = false
      this.digitalizing = false
      this.agreement = {}
      this.documents = {}
      eventBus.$emit('reset-state', resetBarcode)
    },
    digitalize() {
      if (this.digitalizing) {
        return
      }
      let customerAge = moment(this.documents.signedAt).diff(this.agreement.birthDate, 'years')
      if (customerAge < 18) {
        this.makeToast('danger', 'Il cliente NON era maggiorenne al momento della firma!')
        return
      }

      this.digitalizing = true
      PaperAgreementsApi.add(this.agreement)
        .then(id => PaperAgreementsApi.digitalize(id, this.documents))
        .then(() => this.makeToast('success', 'Digitalizzazione avvenuta con successo'))
        .catch(err => {
          switch (err.response.status) {
            case 413:
              this.makeToast('danger', 'File troppo grande')
              break
            default:
              this.makeToast('danger', 'Digitalizzazione fallita')
              break
          }
        })
        .finally(() => this.resetState())
    },
    makeToast(type, message) {
      this.$bvToast.toast(message, {
        title: 'Digitalizzazione',
        variant: type,
        toaster: 'b-toaster-top-center',
        solid: true
      })
    },
  }
}
</script>

<style scoped>

</style>
